import { appServiceApi } from "../../../app/appServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../types";
import {
  CheckButtonForSalaryDisbursmentStatusDataType,
  CheckButtonForSalaryDisbursmentStatusParamsType,
  DisburesementRetryableDataType,
  DisburesementRetryableParamsType,
  GetAllDisbursementBatchDataParamsType,
  GetAllDisbursementBatchDataType,
  GetAllDisbursementDataParamsType,
  GetAllDisbursementDataType,
  GetAllVendorPaymentDataParamsType,
  GetAllVendorPaymentDataType,
  GetSingleDisbursementDataType,
} from "../../../types/portal/disbursementPayment";
import { GetVendorTotalAmountDataType } from "../../../types/portal/vendorPayment";

export const disbursementPaymentApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllDisbursementBatch: builder.query<
      GetAllDisbursementBatchDataType,
      GetQueryArgsType<GetAllDisbursementBatchDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllDisbursementBatch,
        params: queryArgs.params,
      }),
      providesTags: ["GetAllDisbursementBatch"],
    }),

    createDisbursements: builder.mutation({
      query: (data) => ({
        url: API_URL.createDisbursements,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetDisbursmentPayment",
            "GetAllDisbursementBatch",
            "GetSalaryAmount",
          ];

        return [];
      },
    }),

    getAllDisbursements: builder.query<
      GetAllDisbursementDataType,
      GetQueryArgsType<GetAllDisbursementDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllDisbursements,
        params: queryArgs.params,
      }),
      providesTags: ["GetDisbursmentPayment"],
    }),

    getSingleDisbursements: builder.query<
      GetSingleDisbursementDataType,
      string
    >({
      query: (id) => ({
        url: `${API_URL.getSingleDisbursements}/${id}`,
      }),
    }),

    disbursementsPaymentChecker: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.disbursementsPaymentChecker}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetDisbursmentPayment",
            "GetAllDisbursementBatch",
            "GetSalaryAmount",
          ];

        return [];
      },
    }),

    disbursementsPayment: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.disbursementsPayment}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetDisbursmentPayment",
            "GetAllDisbursementBatch",
            "GetSalaryAmount",
          ];

        return [];
      },
    }),

    disbursementsPaymentWithOtp: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.disbursementsPaymentWithOtp}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetDisbursmentPayment",
            "GetAllDisbursementBatch",
            "GetSalaryAmount",
            "CheckSalaryDisbursement",
          ];

        return [];
      },
    }),

    getSalaryAmount: builder.query<
      GetVendorTotalAmountDataType,
      GetQueryArgsType<GetAllDisbursementDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.salaryAmount,
        params: queryArgs.params,
      }),
      providesTags: ["GetSalaryAmount"],
    }),

    sentToChecker: builder.mutation({
      query: ({ data }) => ({
        url: `${API_URL.sentToChecker}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetDisbursmentPayment",
            "GetAllDisbursementBatch",
            "GetSalaryAmount",
          ];

        return [];
      },
    }),

    batchReject: builder.mutation({
      query: ({ data }) => ({
        url: `${API_URL.batchReject}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetDisbursmentPayment",
            "GetAllDisbursementBatch",
            "GetSalaryAmount",
          ];

        return [];
      },
    }),

    checkButtonForSalaryDisbursmentStatus: builder.query<
      CheckButtonForSalaryDisbursmentStatusDataType,
      GetQueryArgsType<CheckButtonForSalaryDisbursmentStatusParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.checkButtonForSalaryDisbursmentStatus,
        params: queryArgs.params,
      }),
      providesTags: ["GetSalaryAmount"],
    }),

    getAllVendors: builder.query<
      GetAllVendorPaymentDataType,
      GetQueryArgsType<GetAllVendorPaymentDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllVendors,
        params: queryArgs.params,
      }),
      providesTags: ["GetAllVendorsPayment"],
    }),

    sentToCheckerVendor: builder.mutation({
      query: ({ data }) => ({
        url: `${API_URL.sentToCheckerVendor}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetAllVendorsPayment",
            "GetAllBatchVendor",
            "GetSalaryAmount",
          ];

        return [];
      },
    }),

    batchRejectVendor: builder.mutation({
      query: ({ data }) => ({
        url: `${API_URL.batchRejectVendor}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetAllVendorsPayment",
            "GetAllBatchVendor",
            "GetSalaryAmount",
          ];

        return [];
      },
    }),

    vendorPaymentsSentToChecker: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.vendorPaymentsSentToChecker}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetAllVendorsPayment",
            "GetAllBatchVendor",
            "GetSalaryAmount",
          ];

        return [];
      },
    }),

    vendorsPaymentWithOtp: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.vendorsPaymentWithOtp}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetAllVendorsPayment",
            "GetAllBatchVendor",
            "GetSalaryAmount",
            "CheckSalaryDisbursement",
          ];

        return [];
      },
    }),

    checkButtonForVendorPaymentsStatus: builder.query<
      CheckButtonForSalaryDisbursmentStatusDataType,
      GetQueryArgsType<CheckButtonForSalaryDisbursmentStatusParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.checkButtonForVendorPaymentsStatus,
        params: queryArgs.params,
      }),
      providesTags: ["GetSalaryAmount"],
    }),

    disburesementRetryable: builder.query<
      DisburesementRetryableDataType,
      GetQueryArgsType<DisburesementRetryableParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.disburesementRetryable,
        params: queryArgs.params,
      }),
      providesTags: ["GetSalaryAmount"],
    }),
  }),
});

export const {
  useCreateDisbursementsMutation,
  useGetAllDisbursementsQuery,
  useGetSingleDisbursementsQuery,
  useDisbursementsPaymentCheckerMutation,
  useDisbursementsPaymentMutation,
  useGetAllDisbursementBatchQuery,
  useDisbursementsPaymentWithOtpMutation,
  useGetSalaryAmountQuery,
  useSentToCheckerMutation,
  useCheckButtonForSalaryDisbursmentStatusQuery,
  useBatchRejectMutation,
  useGetAllVendorsQuery,
  useSentToCheckerVendorMutation,
  useBatchRejectVendorMutation,
  useVendorPaymentsSentToCheckerMutation,
  useVendorsPaymentWithOtpMutation,
  useCheckButtonForVendorPaymentsStatusQuery,
  useDisburesementRetryableQuery,
} = disbursementPaymentApi;
